const Button = ({ resetGame }) => {
    return <button style={{width:'180px',padding:'7px',fontFamily:'consolas'}} onClick={() => resetGame()}>New Game</button>;
};

export default Button;
